<ng-container *ngIf="previewUrl; else uploadAudio">
  <div class="audio-uploader__file flex align-center">
    <audio controls>
      <source [src]="previewUrl" type="audio/ogg" />
      Your browser does not support the audio element.
    </audio>
    <div class="audio-uploader__close">
      <img src="assets/images/close.svg" alt="X" (click)="removeAudio.emit()" />
    </div>
  </div>
</ng-container>

<ng-template #uploadAudio>
  <ng-container *ngIf="!audioUploading; else loading">
    <label class="audio-uploader flex align-center">
      <img src="assets/images/music.svg" alt="Music" />
      <span>Click here to upload an audio file</span>
      <input
        type="file"
        title=""
        (change)="onFileSelction($event)"
        [accept]="allowedAudioType"
      />
    </label>
  </ng-container>
</ng-template>

<ng-template #loading>
  <app-skeleton width="100%" height="50px" radius="30px"></app-skeleton>
</ng-template>
